import {
    Row,
    Col,
    Table,
    Button,
    Pagination,
    Form,
    Select,
    Dropdown,
    Menu,
    message,
    DatePicker,
    Typography,
    Popover
} from "antd";
import { PlusCircleOutlined } from '@ant-design/icons';
import React, { useEffect, useState, useContext } from "react";
import Service from "./../../utils/apiOpen";
import IconVector from '../../assets/images/vector2.png';
import IconSearch from '../../assets/images/IconSearch.png';
import IconDuyetNHD from '../../assets/images/ngunghd.svg';
import IconNgungHD from '../../assets/images/khoa.svg';
import Calendar from '../../assets/images/Calendar.png';
import ThemSanPham from './modal/them-san-pham';
import XacNhanNgung from './modal/xac-nhan-ngung';
import XacNhanDuyetNgung from './modal/xac-nhan-duyet-ngung';
import LyDoNgung from './modal/ly-do-ngung';
import LyDoTuChoi from './modal/ly-do-tu-choi-duyet';
import dayjs from "dayjs";
import { LocalState } from "./index";

function ListOrder() {
    const { RenderStatus, MessageSucces, config, goStep } = useContext(LocalState);
    const [loading, setLoading] = useState(false);
    const [openMD, setOpenMD] = useState({
        TaoSP: false,
        XacNhanNgung: false,
        LyDoNgung: false,
        XacNhanDuyetNgung: false,
        LyDoTuChoi: false
    });
    const [form] = Form.useForm();
    const formRef = React.createRef();
    const [formData, setFormData] = useState({ page: 1, pageSize: 10 });
    const [total, setTotal] = useState(0);
    const [detail, setDetail] = useState({});
    var [data, setData] = useState([]);
    const { Paragraph, Text } = Typography;
    const { Option } = Select;

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            getList();
        }, 100);
        return () => clearTimeout(timeoutId);
    }, [formData]);

    const getList = async () => {
        setLoading(true);
        const dataForm = {
            ...formData,
            fromDate: formData.fromDate ? dayjs(formData.fromDate).format('YYYY-MM-DD') : undefined,
            toDate: formData.toDate ? dayjs(formData.toDate).format('YYYY-MM-DD') : undefined,
        }
        await Service.openApiCall("GET", `/v1/affiliate/portal/product`, dataForm)
            .then((res) => {
                setLoading(false);
                let data = res?.data;
                if (data.success) {
                    setData(data?.data?.data);
                    setTotal(data?.data?.total);
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err?.response) {
                    message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
                }
            });
    };

    const onFinish = (val) => {
        form
            .validateFields()
            .then(async (values) => {
                setFormData({
                    ...formData,
                    ...values,
                    page: 1
                });
            })
            .catch((err) => {

            });
    };

    const handleCancel = () => {
        setOpenMD({
            TaoSP: false,
            XacNhanNgung: false,
            LyDoNgung: false,
            XacNhanDuyetNgung: false,
            LyDoTuChoi: false
        });
    }

    const columns = [
        {
            title: " ",
            render: (item, record, index) => (
                <div style={{ width: "30px", textAlign: "left" }}>
                    {index + 1 + (formData.page - 1) * formData.pageSize}
                </div>
            ),
        },
        {
            title: 'Tên sản phẩm',
            render: (item, record, index) => (
                <div style={{ width: "200px", textAlign: "left" }}>
                    {item?.pbpTitle}
                </div>
            )
        },
        {
            title: 'Mã sản phẩm',
            render: (item, record, index) => (
                <div style={{ width: "130px", textAlign: "left" }}>
                    {item.code}
                </div>
            )
        },
        {
            title: 'Link sản phẩm',
            render: (item, record, index) => (
                <div onClick={() => item.url ? window.open(item.url) : ''} style={{ width: "200px", textAlign: "left", cursor: 'pointer' }}>
                    <Paragraph
                        style={{ margin: 0 }}
                        ellipsis={{
                            symbol: "Xem thêm",
                            rows: 1,
                            expandable: false,
                            // onExpand: () => setUid(data?.uid),
                        }
                        }
                    >
                        {item.url || "-"}
                    </Paragraph>
                </div>
            )
        },
        {
            title: 'Loại bảo hiểm',
            render: (item, record, index) => (
                <div style={{ width: "130px", textAlign: "left" }}>
                    {item.categoryTitle || '-'}
                </div>
            )
        },
        {
            title: 'Nhà bảo hiểm',
            render: (item, record, index) => (
                <div style={{ width: "120px", textAlign: "left" }}>
                    {item.providerTitle || '-'}
                </div>
            )
        },
        {
            title: 'Hoa hồng',
            render: (item, record, index) => (
                <div style={{ width: "70px", textAlign: "center" }}>
                    {item?.commissionRate || '-'}
                </div>
            )
        }, {
            title: 'Lý do ngừng hoạt động',
            render: (data, record, index) => (
                <div style={{ textAlign: "left", width: 200 }}>
                    <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                        {
                            <Paragraph
                                style={{ margin: 0 }}
                                ellipsis={{
                                    symbol: " ",
                                    rows: 2,
                                    expandable: true,
                                    suffix: data?.reasonForSuspension?.length > 67 ?
                                        <Popover open={data?.reasonForSuspension?.length > 67 ? undefined : false} trigger="click" placement="top" title={""} content={data?.reasonForSuspension}>
                                            <span style={{ color: '#0044CC', textDecoration: 'underline', marginLeft: 5, cursor:'pointer'}}>Xem thêm</span>
                                        </Popover>
                                        : ''
                                }}
                            >
                                {data?.reasonForSuspension || "-"}
                            </Paragraph>
                        }
                    </div>
                </div>
            )
        },
        {
            title: 'Trạng thái',
            fixed: "right",
            render: (item, record, index) => (
                <div style={{ width: "130px", textAlign: "left" }}>
                    {RenderStatus(item?.statusCode)}
                </div>
            )
        },
        {
            title: "",
            fixed: "right",
            align: "center",
            render: (item, record, index) => (
                <div style={{ width: "50px" }}>
                    <Dropdown
                        overlay={Action(item)}
                        trigger={["click"]}
                        disabled={item.statusCode === 'ngung_hoat_dong'? true : false}
                    >
                        <a className="ant-dropdown-link">
                            <img
                                src={IconVector}
                                style={{ width: 16 }}
                            />
                        </a>
                    </Dropdown>
                </div>
            ),
        },
    ];

    const dropdownAction = [
        {
            title: "Duyệt ngừng hoạt động",
            avatar: (
                <img
                    src={IconDuyetNHD}
                    style={{ width: 18 }}
                />
            )
        },
        {
            title: "Ngừng hoạt động",
            avatar: (
                <img
                    src={IconNgungHD}
                    style={{ width: 16 }}
                />
            )
        },
    ]

    const Action = (dataNote) => (
        <Menu
            shape="circle"
            className="custom-menu-dropdown"
        >
            {dropdownAction.map((value, index) => (
                <Menu.Item
                    key={index + 1}
                    icon={value.avatar}
                    style={{
                        display: (dataNote.statusCode === 'dang_hoat_dong' && index === 1) ? '' :
                            (dataNote.statusCode === 'cho_kiem_duyet' && index === 0) ? '' :
                                'none'
                    }}
                    onClick={(e) => {
                        switch (index) {
                            case 0:
                                setDetail(dataNote);
                                setOpenMD({ ...openMD, XacNhanDuyetNgung: true });
                                break;
                            case 1:
                                setDetail(dataNote);
                                setOpenMD({ ...openMD, LyDoNgung: true });
                                break;
                            default:
                                break;
                        }
                    }}
                >
                    <div style={{ minWidth: 150 }}>{value.title}</div>
                </Menu.Item>
            ))
            }
        </Menu >
    );

    return (
        <>
            {
                openMD.TaoSP &&
                <ThemSanPham MessageSucces={MessageSucces} config={config} handleCancel={handleCancel} getList={getList} />
            }
            {
                openMD.LyDoNgung &&
                <LyDoNgung detail={detail} setDetail={setDetail} openMD={openMD} setOpenMD={setOpenMD} config={config} handleCancel={handleCancel} getList={getList} />
            }
            {
                openMD.XacNhanNgung &&
                <XacNhanNgung MessageSucces={MessageSucces} detail={detail} openMD={openMD} setOpenMD={setOpenMD} config={config} handleCancel={handleCancel} getList={getList} />
            }
            {
                openMD.XacNhanDuyetNgung &&
                <XacNhanDuyetNgung MessageSucces={MessageSucces} detail={detail} openMD={openMD} setOpenMD={setOpenMD} config={config} handleCancel={handleCancel} getList={getList} />
            }
            {
                openMD.LyDoTuChoi &&
                <LyDoTuChoi MessageSucces={MessageSucces} detail={detail} setDetail={setDetail} openMD={openMD} setOpenMD={setOpenMD} config={config} handleCancel={handleCancel} getList={getList} />
            }
            <div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: 20 }}>
                    <Button
                        onClick={() => setOpenMD({ ...openMD, TaoSP: true })}
                        style={{
                            background: "#0B7CE4",
                            color: "#ffffff",
                            textAlign: "center",
                            borderRadius: 50,
                            border: "1px solid #0B7CE4",
                            height: 33,
                            alignItems: 'center', display: 'flex'
                        }}
                    >
                        <PlusCircleOutlined style={{ fontSize: 18 }} />
                        Thêm sản phẩm
                    </Button>
                </div>
                <Form
                    ref={formRef}
                    layout={"vertical"}
                    scrollToFirstError
                    form={form}
                    onFinish={onFinish}
                    autoComplete="off"
                // initialValues={{
                //     fromDate: moment(),
                //     toDate: moment(),
                // }}
                >
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <span style={{ color: '#969696' }}>Từ</span>
                            <Form.Item
                                name={"fromDate"}
                                style={{ margin: 0, width: 160 }}
                                rules={[
                                    {
                                        required: false,
                                        message: "Vui lòng chọn thông tin",
                                    },
                                ]}
                            >
                                <DatePicker suffixIcon={<img src={Calendar} width={16} />} placeholder={'dd/mm/yyyy'} style={{ margin: 0, margin: '0px 10px' }} format='DD/MM/YYYY' />
                            </Form.Item>
                            <span style={{ color: '#969696' }}>đến</span>
                            <Form.Item
                                name={"toDate"}
                                style={{ margin: 0, width: 160 }}
                                rules={[
                                    {
                                        required: false,
                                        message: "Vui lòng chọn thông tin",
                                    },
                                ]}
                            >
                                <DatePicker suffixIcon={<img src={Calendar} width={16} />} placeholder={'dd/mm/yyyy'} style={{ margin: 0, margin: '0px 10px' }} format='DD/MM/YYYY' />
                            </Form.Item>
                        </div>
                        <Form.Item
                            className="username"
                            name={"status"}
                            style={{ margin: 0, width: 160, marginRight: 10 }}
                            rules={[
                                {
                                    required: false,
                                    message: "Vui lòng chọn thông tin",
                                },
                            ]}
                        >
                            <Select
                                dropdownStyle={{ width: 'auto' }}
                                showSearch={false}
                                allowClear={true}
                                className="custom-select"
                                style={{ textAlign: "left" }}
                                placeholder={<span style={{ color: '#343A40' }}>Trạng thái</span>}
                            >
                                {
                                    (config?.status || []).map((item) => (
                                        <Option key={item?.code} value={item?.code} >{item?.title}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            className="username"
                            name={"providerCode"}
                            style={{ margin: 0, width: 160, marginRight: 10 }}
                            rules={[
                                {
                                    required: false,
                                    message: "Vui lòng chọn thông tin",
                                },
                            ]}
                        >
                            <Select
                                dropdownStyle={{ width: '200px' }}
                                showSearch={true}
                                filterOption={(input, node) => {
                                    const normalize = str =>
                                        str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                                    return normalize(node?.children || '').includes(normalize(input));
                                }}
                                allowClear={true}
                                className="custom-select"
                                style={{ textAlign: "left" }}
                                placeholder={<span style={{ color: '#343A40' }}>Nhà bảo hiểm</span>}
                            >
                                {
                                    (config?.providers || []).map((item) => (
                                        <Option key={item?.code} value={item?.code} >{item?.title}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            className="username"
                            name={"categoryCode"}
                            style={{ margin: 0, width: 160, marginRight: 10 }}
                            rules={[
                                {
                                    required: false,
                                    message: "Vui lòng chọn thông tin",
                                },
                            ]}
                        >
                            <Select
                                dropdownStyle={{ width: '160px' }}
                                showSearch={false}
                                allowClear={true}
                                className="custom-select"
                                style={{ textAlign: "left" }}
                                placeholder={<span style={{ color: '#343A40' }}>Loại bảo hiểm</span>}
                            >
                                {
                                    (config?.insuranceCategory || []).map((item) => (
                                        <Option key={item?.code} value={item?.code} >{item?.title}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>

                        <Button
                            disabled={loading}
                            htmlType="submit"
                            style={{
                                background: "#0B7CE4",
                                color: "#ffffff",
                                textAlign: "center",
                                borderRadius: 6,
                                border: "1px solid #0B7CE4",
                                height: 33,
                                alignItems: 'center', display: 'flex'
                            }}
                        >
                            <img
                                src={IconSearch}
                                width="18"
                                style={{ marginRight: 10 }}
                            />
                            Tìm kiếm
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="tabled" style={{ marginTop: 20 }}>
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Table
                            loading={loading}
                            dataSource={data} columns={columns}
                            pagination={false}
                            className="ant-border-space table-custom"
                            rowClassName={() => "rowClassName1"}
                            bordered={false}
                            scroll={{ x: "auto" }}
                            showHeader={true}
                        />
                        <div style={{ display: 'flex', margin: "10px", alignItems: 'center', justifyContent: 'center' }}>
                            <Pagination
                                total={total || 10}
                                pageSize={formData?.pageSize}
                                onChange={(e) => {
                                    setFormData({ ...formData, page: e })
                                }}
                                showSizeChanger={false}
                                current={formData?.page}
                                size="small"
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default ListOrder;
